import { render } from "./CourierNotice.vue?vue&type=template&id=5b4fca1c&scoped=true"
const script = {}

import "./CourierNotice.vue?vue&type=style&index=0&id=5b4fca1c&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4fca1c"]])

export default __exports__